const normalizeAmount = (number, precisionThreshold = 0.01) => {
  const num = Number(number).toFixed(2)

  if (isNaN(num)) {
    return String(number)
  }

  // Проверяем, является ли дробная часть незначительной
  const fractionalPart = Math.abs(num - Math.trunc(num))

  if (fractionalPart < precisionThreshold && fractionalPart > 0) {
    return Math.trunc(num).toString()
  }

  // Стандартное форматирование
  const str = num.toString()
  return str
    .replace(/\.0+$/, '')
    .replace(/(\.\d*?)0+$/, '$1')
    .replace(/\.$/, '')
}

const getCommissionNewLava = percent => {
  if (!percent) return 0

  return normalizeAmount((1 - percent) * 100)
}

module.exports = {
  normalizeAmount,
  getCommissionNewLava
}
